import React, { useContext, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import * as XLSX from "xlsx";
import CheckCircleOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import ErrorOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import RefreshIcon from "@material-ui/icons/Refresh";

import { toast } from "react-toastify";
import api from "../../services/api";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";
import PremiumDashboard from "./PremiumDashboard";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../../utils/rolloutFeatures";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.type === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  mainPaper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: "transparent !important",
    borderRadius: "10px",
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    marginRight: theme.spacing(1),
    borderRadius: 5,
    height: 10,
  },
  progressLabel: {
    minWidth: 50,
    textAlign: "right",
    fontWeight: 500,
    color: theme.palette.type === "light" ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  infoCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
  },
  infoIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },

  /* ===== Redesenho visual — Dashboard (só apresentação) ===== */
  dashPrimary: { color: "#D4AF37" },
  dashboardShell: {
    position: "relative",
    padding: "26px 26px 40px",
    borderRadius: 24,
    background: theme.palette.type === "light"
      ? "radial-gradient(circle at 8% 0%, rgba(212,175,55,.13), transparent 28%), linear-gradient(180deg,#FBFAF7 0%,#F4F1E9 100%)"
      : "radial-gradient(circle at 8% 0%, rgba(212,175,55,.12), transparent 30%), #101011",
    [theme.breakpoints.down("sm")]: { padding: "14px 12px 28px", borderRadius: 16 },
  },
  executiveHero: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 22,
    padding: "26px 28px",
    color: "#fff",
    background: "linear-gradient(118deg, #070708 0%, #111113 62%, #241D0B 100%)",
    border: "1px solid rgba(242,214,117,.26)",
    boxShadow: "0 24px 58px rgba(8,8,9,.30)",
    "&:before": {
      content: '""', position: "absolute", width: 280, height: 280, borderRadius: "50%",
      right: -80, top: -170, background: "rgba(242,214,117,.10)",
    },
    "&:after": {
      content: '""', position: "absolute", width: 160, height: 160, borderRadius: "50%",
      right: 110, bottom: -130, background: "rgba(212,175,55,.22)",
    },
    [theme.breakpoints.down("sm")]: { padding: "21px 18px", borderRadius: 18 },
  },
  dashHeaderRow: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 20,
  },
  heroEyebrow: { fontSize: 11, fontWeight: 900, letterSpacing: "2.2px", textTransform: "uppercase", color: "#F2D675", marginBottom: 8 },
  dashTitle: {
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: "-0.035em",
    margin: 0,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: { fontSize: 26 },
  },
  dashPeriodText: {
    fontSize: 13.5,
    color: "rgba(255,255,255,.72)",
    marginTop: 7,
  },
  periodPill: { display: "inline-flex", alignItems: "center", padding: "5px 10px", marginLeft: 5, borderRadius: 99, color: "#fff", background: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.16)", fontWeight: 700 },
  dashRefreshBtn: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: 11,
    minHeight: 40,
    background: "linear-gradient(135deg,#F2D675,#D4AF37)",
    color: "#111113",
    boxShadow: "0 10px 26px rgba(212,175,55,.24)",
    "& .MuiButton-startIcon": { color: "#111113" },
    "&:hover": { background: "linear-gradient(135deg,#FFE9A0,#DDBB4C)", boxShadow: "0 12px 30px rgba(212,175,55,.32)" },
  },
  dashFilterBtn: { textTransform: "none", fontWeight: 800, borderRadius: 11, minHeight: 40, color: "#F7E7AE", borderColor: "rgba(242,214,117,.42)", background: "rgba(212,175,55,.08)", "&:hover": { borderColor: "#F2D675", background: "rgba(212,175,55,.16)" } },
  sectionHead: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: 12,
    margin: "30px 2px 13px",
    flexWrap: "wrap",
  },
  sectionHeadTitle: {
    fontSize: 17,
    fontWeight: 800,
    letterSpacing: "-0.015em",
    color: theme.palette.type === "light" ? "#101828" : theme.palette.text.primary,
  },
  sectionHeadHint: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  liveBand: {
    border: `1px solid ${theme.palette.type === "light" ? "#E4D7AC" : "rgba(242,214,117,.18)"}`,
    background: theme.palette.type === "light"
      ? "linear-gradient(135deg, #FFFDF7, #F6F0DC)"
      : "linear-gradient(135deg,#171719,#211D12)",
    borderRadius: 20,
    padding: "20px",
    marginTop: 18,
    boxShadow: "0 14px 34px rgba(63,48,8,.08)",
  },
  liveHeaderMain: { display: "flex", alignItems: "center", gap: 9, flexWrap: "wrap" },
  liveBadge: {
    display: "inline-flex", alignItems: "center", gap: 6, padding: "5px 10px",
    borderRadius: 99, background: "rgba(212,175,55,.15)", color: theme.palette.type === "light" ? "#765A08" : "#F2D675",
    border: "1px solid rgba(212,175,55,.32)", fontSize: 10, fontWeight: 900,
    letterSpacing: ".9px",
  },
  liveScope: {
    width: "100%", marginTop: 8, padding: "10px 12px", borderRadius: 11,
    background: theme.palette.type === "light" ? "#FBF7EA" : "rgba(212,175,55,.07)",
    border: "1px solid rgba(212,175,55,.28)",
    color: theme.palette.type === "light" ? "#332A14" : theme.palette.text.primary,
    fontSize: 14, fontWeight: 850, lineHeight: 1.45,
    boxShadow: "0 6px 18px rgba(63,48,8,.05)",
  },
  periodScope: {
    width: "100%", padding: "10px 12px", borderRadius: 11,
    background: theme.palette.type === "light" ? "#FBF7EA" : "rgba(212,175,55,.07)",
    border: "1px solid rgba(212,175,55,.28)",
    color: theme.palette.type === "light" ? "#332A14" : theme.palette.text.primary,
    fontSize: 14, fontWeight: 850, lineHeight: 1.45,
    boxShadow: "0 6px 18px rgba(63,48,8,.05)",
  },
  liveCardBadge: {
    position: "absolute", top: 14, right: 14, borderRadius: 99,
    padding: "4px 8px", background: "#111113", color: "#F2D675",
    fontSize: 9, fontWeight: 900, letterSpacing: ".8px",
  },
  liveDot: {
    width: 7,
    height: 7,
    color: "#D4AF37",
  },
  dashCard: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    border: `1px solid ${theme.palette.type === "light" ? "#E8E0C9" : "rgba(242,214,117,.14)"}`,
    padding: "18px 18px 16px",
    height: "100%",
    background: theme.palette.background.paper,
    boxShadow: "0 10px 28px rgba(43,34,10,.065)",
    transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease",
    "&:hover": { transform: "translateY(-3px)", borderColor: "#D4AF37", boxShadow: "0 16px 38px rgba(79,60,8,.13)" },
  },
  featuredCard: { minHeight: 164, "&:before": { content: '""', position: "absolute", left: 0, top: 0, bottom: 0, width: 4, background: "linear-gradient(#F2D675,#A67C00)" } },
  bentoPanel: { borderRadius: 20, border: `1px solid ${theme.palette.type === "light" ? "#E8E0C9" : "rgba(242,214,117,.14)"}`, background: theme.palette.background.paper, padding: 22, height: "100%", boxShadow: "0 12px 32px rgba(43,34,10,.065)" },
  panelTitle: { fontSize: 14, fontWeight: 800, color: theme.palette.text.primary, marginBottom: 3 },
  panelIntro: { fontSize: 11.5, color: theme.palette.text.secondary, marginBottom: 16, display: "block" },
  metricRow: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, padding: "13px 0", borderBottom: `1px solid ${theme.palette.type === "light" ? "#EEF2F6" : theme.palette.divider}`, "&:last-child": { borderBottom: 0 } },
  metricRowLabel: { fontSize: 12.5, fontWeight: 700, color: theme.palette.text.secondary },
  metricRowValue: { fontSize: 20, lineHeight: 1, fontWeight: 800, letterSpacing: "-.02em", color: theme.palette.text.primary, textAlign: "right", fontVariantNumeric: "tabular-nums" },
  visibleNotice: { display: "flex", gap: 9, alignItems: "flex-start", marginTop: 14, padding: "11px 12px", borderRadius: 11, background: "#FFF7E8", border: "1px solid #FCE2AF", color: "#945F0B", fontSize: 11.5, lineHeight: 1.45 },
  dashIconWrap: {
    width: 38,
    height: 38,
    borderRadius: 11,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg,#FBF4D8,#EFE0A7)",
    color: "#8A6809",
    marginBottom: 14,
    "& svg": { fontSize: 19 },
  },
  dashIconGood: { background: "linear-gradient(135deg,#FBF4D8,#EFE0A7)", color: "#8A6809" },
  dashIconWarn: { backgroundColor: "#FCF3E1", color: "#B9790A" },
  dashIconCrit: { backgroundColor: "#FBEBEA", color: "#C6362E" },
  dashValue: {
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: "-0.035em",
    lineHeight: 1.15,
    fontVariantNumeric: "tabular-nums",
    color: theme.palette.text.primary,
  },
  dashValueMuted: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  dashLabel: {
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  dashSub: {
    fontSize: 11.5,
    color: theme.palette.text.secondary,
    marginTop: 7,
    lineHeight: 1.45,
    display: "block",
  },
  dashWarnNote: {
    fontSize: 11.5,
    color: "#945F0B",
    background: "#FFF7E8",
    border: "1px solid #FCE2AF",
    borderRadius: 10,
    padding: "9px 10px",
    marginTop: 12,
    lineHeight: 1.4,
    display: "block",
  },
  npsCard: {
    borderRadius: 18,
    border: `1px solid ${theme.palette.type === "light" ? "#E4E9F0" : theme.palette.divider}`,
    padding: "14px 16px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
  },
  npsTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: 8,
  },
  npsLabel: { fontSize: 13, fontWeight: 600, color: theme.palette.text.secondary },
  npsValue: { fontSize: 18, fontWeight: 700, fontVariantNumeric: "tabular-nums" },
  npsBarTrack: {
    height: 7,
    borderRadius: 100,
    backgroundColor: theme.palette.type === "light" ? "#F0F2F5" : theme.palette.action.hover,
    overflow: "hidden",
  },
  ratingBadge: {
    fontSize: 30,
    fontWeight: 800,
    padding: "12px 18px",
    borderRadius: 14,
    color: "#765A08",
    background: "linear-gradient(135deg,#FBF4D8,#EFE0A7)",
  },
  chartPanel: { borderRadius: 20, border: `1px solid ${theme.palette.type === "light" ? "#E8E0C9" : "rgba(242,214,117,.14)"}`, padding: "22px 20px", background: theme.palette.background.paper, minHeight: 380, boxShadow: "0 12px 32px rgba(43,34,10,.065)" },
  chartHead: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, margin: "0 4px 18px", paddingBottom: 14, borderBottom: `1px solid ${theme.palette.type === "light" ? "#EEE7D4" : "rgba(242,214,117,.12)"}` },
  chartTitle: { fontSize: 14, fontWeight: 800, color: theme.palette.text.primary },
  chartHint: { fontSize: 11.5, color: theme.palette.text.secondary },
  chartAccent: { width: 9, height: 9, borderRadius: "50%", background: "#D4AF37", boxShadow: "0 0 0 5px rgba(212,175,55,.14)" },
  tablePanel: {
    borderRadius: 20, overflow: "auto",
    border: `1px solid ${theme.palette.type === "light" ? "#E8E0C9" : "rgba(242,214,117,.14)"}`,
    background: theme.palette.background.paper, boxShadow: "0 12px 32px rgba(43,34,10,.065)",
    "& table": { minWidth: 720 },
    "& thead th": { background: theme.palette.type === "light" ? "#F7F2E3" : "#191817", color: theme.palette.text.secondary, fontSize: 11, fontWeight: 800, letterSpacing: ".6px", textTransform: "uppercase", borderBottom: "1px solid #DED1A6" },
    "& tbody td": { borderBottom: `1px solid ${theme.palette.type === "light" ? "#EEE7D4" : theme.palette.divider}`, paddingTop: 14, paddingBottom: 14 },
    "& tbody tr": { transition: "background .18s ease" },
    "& tbody tr:hover": { background: theme.palette.type === "light" ? "#FBF7EA" : "rgba(212,175,55,.06)" },
  },
}));

const LegacyDashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [rankingByUser, setRankingByUser] = useState({});
  const [rankingLoading, setRankingLoading] = useState(true);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [customPeriod, setCustomPeriod] = useState(false);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const [chartsRefreshKey, setChartsRefreshKey] = useState(0);

  // Tempo de Resposta
  const [rtData, setRtData] = useState({ avgMinutes: 0, totalResponses: 0 });
  const [rtUserId, setRtUserId] = useState("all");
  const [rtQueueId, setRtQueueId] = useState("all");
  const [rtStartHour, setRtStartHour] = useState("0");
  const [rtEndHour, setRtEndHour] = useState("23");
  const [rtDateFrom, setRtDateFrom] = useState(nowIni);
  const [rtDateTo, setRtDateTo] = useState(now);
  const [rtLoading, setRtLoading] = useState(false);
  const [rtUsers, setRtUsers] = useState([]);
  const [rtQueues, setRtQueues] = useState([]);

  const { user } = useContext(AuthContext);
  const [tokenWarning, setTokenWarning] = useState(null);

  // Regra nova (achado de auditoria, Codex): NPS/avaliacao so aparece no
  // Dashboard quando a empresa realmente tem essa pesquisa configurada.
  // Antes disso, o card "Sem avaliacao" contava TODOS os tickets fechados
  // sem nota -- mesmo quando nenhuma pesquisa jamais foi enviada -- dando a
  // impressao errada de que existe avaliacao pendente. So visual: nao ativa
  // nem desativa nada, nao mexe em ticket/Resolver/UpdateTicketService.
  const [userRatingEnabled, setUserRatingEnabled] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/settings");
        const setting = Array.isArray(data) ? data.find((s) => s.key === "userRating") : null;
        if (mounted) setUserRatingEnabled(setting?.value === "enabled");
      } catch (err) {
        // Falha ao buscar configuracao nao pode quebrar o Dashboard -- mantem
        // oculto por seguranca (nao mostra NPS se nao confirmou que esta ligado).
        if (mounted) setUserRatingEnabled(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    api.get("/companiesPlan").then(({ data }) => {
      const limit = data?.plan?.aiTokensLimit || 0;
      if (limit === 0) return;
      api.get("/companies/" + data.id).then(({ data: comp }) => {
        const used = comp?.aiTokensUsed || 0;
        const pct = Math.round((used / limit) * 100);
        if (pct >= 90) {
          setTokenWarning({ pct, used, limit });
        }
      }).catch(() => {});
    }).catch(() => {});
  }, []);

  useEffect(() => {
    let isMounted = true;

    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
        fetchAttendantRanking();
      }
    }

    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Carrega listas de usuarios e filas para filtros do tempo de resposta
  useEffect(() => {
    api.get('/users/list').then(({ data }) => {
      setRtUsers(Array.isArray(data.users) ? data.users : (Array.isArray(data) ? data : []));
    }).catch(() => {});
    api.get('/queue').then(({ data }) => {
      setRtQueues(Array.isArray(data) ? data : []);
    }).catch(() => {});
    fetchResponseTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  async function fetchData(explicitDateStart = dateStartTicket, explicitDateEnd = dateEndTicket) {
    setLoading(true);
    console.log('Iniciando fetchData...');

    let params = {};

    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(explicitDateStart) && moment(explicitDateStart).isValid()) {
        params = {
          ...params,
          date_from: moment(explicitDateStart).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', explicitDateStart);
      }

      if (!isEmpty(explicitDateEnd) && moment(explicitDateEnd).isValid()) {
        params = {
          ...params,
          date_to: moment(explicitDateEnd).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', explicitDateEnd);
      }
    }

    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }

    console.log('Parâmetros finais para busca:', params);

    try {
      const data = await find(params);
      console.log('Dados recebidos no componente:', data);

      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};

      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);

      setCounters(safeCounters);

      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }

      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);

      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
      setLastUpdatedAt(new Date());
      return true;
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error('Erro ao carregar dados do dashboard');

      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
      return false;
    } finally {
      setLoading(false);
    }
  }

  // Busca tempo de resposta
  const fetchResponseTime = async (dateFromOverride = rtDateFrom, dateToOverride = rtDateTo) => {
    setRtLoading(true);
    try {
      const params = new URLSearchParams();
      if (rtUserId !== "all") params.append("userId", rtUserId);
      if (rtQueueId !== "all") params.append("queueId", rtQueueId);
      params.append("startHour", rtStartHour);
      params.append("endHour", rtEndHour);
      if (dateFromOverride) params.append("dateFrom", dateFromOverride);
      if (dateToOverride) params.append("dateTo", dateToOverride);
      const { data } = await api.get(`/dashboard/response-time?${params.toString()}`);
      setRtData(data);
    } catch (e) {
      console.error("Erro tempo resposta:", e);
    } finally {
      setRtLoading(false);
    }
  };

  // Busca Media Inicio / Media Resposta por atendente (reaproveita o mesmo
  // endpoint ja usado em Metricas de Atendimento, sem duplicar formula)
  const fetchAttendantRanking = async (dateFromOverride = dateStartTicket, dateToOverride = dateEndTicket) => {
    setRankingLoading(true);
    try {
      const params = {};
      if (dateFromOverride) params.dateFrom = dateFromOverride;
      if (dateToOverride) params.dateTo = dateToOverride;
      const { data } = await api.get("/performance/ranking", { params });
      const map = {};
      (data?.users || []).forEach((u) => {
        map[u.id] = {
          avgStartMinutes: u.avgStartMinutes,
          avgResponseMinutes: u.avgResponseMinutes
        };
      });
      setRankingByUser(map);
    } catch (e) {
      console.error("Erro ao buscar ranking de atendentes:", e);
    } finally {
      setRankingLoading(false);
    }
  };

  const handleApplyPeriod = async (newDateStart, newDateEnd, newQueue) => {
    if (!moment(newDateStart, "YYYY-MM-DD", true).isValid() || !moment(newDateEnd, "YYYY-MM-DD", true).isValid()) {
      toast.error("Informe um período válido");
      return;
    }
    if (moment(newDateStart).isAfter(moment(newDateEnd))) {
      toast.error("A data inicial não pode ser maior que a data final");
      return;
    }

    const success = await fetchData(newDateStart, newDateEnd);
    if (!success) return;

    setDateStartTicket(newDateStart);
    setDateEndTicket(newDateEnd);
    setQueueTicket(newQueue);
    setRtDateFrom(newDateStart);
    setRtDateTo(newDateEnd);
    setCustomPeriod(newDateStart !== nowIni || newDateEnd !== now);
    setChartsRefreshKey((value) => value + 1);
    fetchResponseTime(newDateStart, newDateEnd);
    fetchAttendantRanking(newDateStart, newDateEnd);
  };

  const handleRefreshDashboard = () => {
    fetchData(dateStartTicket, dateEndTicket);
    fetchResponseTime(dateStartTicket, dateEndTicket);
    fetchAttendantRanking(dateStartTicket, dateEndTicket);
    setChartsRefreshKey((value) => value + 1);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatMinutes(m) {
    const val = parseFloat(m);
    if (!val || isNaN(val) || val <= 0) return "—";
    const totalSec = Math.round(val * 60);
    if (totalSec < 60) return totalSec + " seg";
    const min = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    if (min >= 60) {
      const h = Math.floor(min / 60);
      const remMin = min % 60;
      return remMin > 0 ? h + "h " + String(remMin).padStart(2, "0") + "m" : h + "h";
    }
    if (sec === 0) return min + " min";
    return min + "m " + sec + "s";
  }

  const GetUsers = () => {
    let userOnline = 0;
    attendants.filter((user) => (user.profile || "").toLowerCase() !== "admin").forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    return userOnline;
  };

  const GetAttendantsCount = () =>
    attendants.filter((attendant) => (attendant.profile || "").toLowerCase() !== "admin").length;

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  const periodLabel = period > 0
    ? `Últimos ${period} dias`
    : `${moment(dateStartTicket).isValid() ? moment(dateStartTicket).format("DD/MM/YYYY") : dateStartTicket} – ${moment(dateEndTicket).isValid() ? moment(dateEndTicket).format("DD/MM/YYYY") : dateEndTicket}`;

  const liveIndicators = [
    {
      label: "Em Atendimento",
      value: counters.supportHappening || 0,
      icon: <CallIcon />,
      tone: "good",
      subtext: "Tickets com atendente atribuído e conversa ativa no momento."
    },
    {
      label: "Aguardando",
      value: counters.supportPending || 0,
      icon: <HourglassEmptyIcon />,
      tone: "warn",
      subtext: "Tickets aguardando aceite ou atendimento, podendo já estar atribuídos a um responsável."
    },
    {
      label: "Atendentes Online Agora",
      value: `${GetUsers()}/${GetAttendantsCount()}`,
      icon: <RecordVoiceOverIcon />,
      tone: "neutral",
      subtext: "Atendentes online agora / total de atendentes cadastrados no sistema."
    },
  ];

  const periodIndicators = {
    finalizados: {
      label: "Finalizados",
      value: counters.supportFinished || 0,
      icon: <CheckCircleIcon />,
      tone: "good",
      subtext: "Tickets encerrados no período selecionado pelo filtro de datas."
    },
    grupos: {
      label: "Grupos",
      value: counters.supportGroups || 0,
      icon: <Groups />,
      tone: "neutral",
      subtext: "Mensagens recebidas em grupos de WhatsApp monitorados pela plataforma."
    },
    novosContatos: {
      label: "Novos Leads",
      value: counters.leads || 0,
      icon: <GroupAddIcon />,
      tone: "neutral",
      subtext: "Novos contatos que iniciaram uma conversa com a empresa pela primeira vez no período selecionado."
    },
    mensagensRecebidas: {
      label: "Mensagens Recebidas",
      value: `${GetMessages(false, false)}`,
      muted: `/ ${GetMessages(true, false)} total`,
      icon: <MessageIcon />,
      tone: "neutral",
      subtext: "Período filtrado / total histórico. Mensagens enviadas pelos clientes."
    },
    mensagensEnviadas: {
      label: "Mensagens Enviadas (empresa)",
      value: `${GetMessages(false, true)}`,
      muted: `/ ${GetMessages(true, true)} total`,
      icon: <SendIcon />,
      tone: "neutral",
      warning: "O histórico atual não identifica se o envio foi humano, IA, fluxo, chatbot ou campanha.",
      subtext: "Período filtrado / total histórico. Mensagens enviadas pelos atendentes."
    },
    tempoMedioEspera: {
      label: "T.M. de Espera",
      value: formatMinutes(counters.avgWaitTime),
      icon: <TimerIcon />,
      tone: "neutral",
      subtext: "Tempo médio que o cliente esperou na fila antes de ser aceito por um atendente."
    },
    iniciadosPelaEmpresa: {
      label: "Iniciados pela empresa",
      value: counters.activeTickets || 0,
      icon: <ArrowUpward />,
      tone: "neutral",
      subtext: "Conversas iniciadas ativamente pela empresa, atendente ou automação no período selecionado."
    },
    iniciadosPeloCliente: {
      label: "Iniciados pelo cliente",
      value: counters.passiveTickets || 0,
      icon: <ArrowDownward />,
      tone: "good",
      subtext: "Conversas iniciadas pelo cliente e recebidas pela empresa no período selecionado."
    },
  };

  const npsRows = [
    { label: "Score (NPS)", value: counters.npsScore || 0, color: "#A67C00" },
    { label: "Promotores", value: counters.npsPromotersPerc || 0, color: "#D4AF37" },
    { label: "Neutros", value: counters.npsPassivePerc || 0, color: "#B9790A" },
    { label: "Detratores", value: counters.npsDetractorsPerc || 0, color: "#C6362E" },
  ];

  const attendanceInfoCards = [
    { label: "Total de Atendimentos", value: counters.tickets || 0 },
    ...(userRatingEnabled ? [
      { label: "Aguardando avaliação", value: counters.waitRating || 0 },
      { label: "Sem avaliação", value: counters.withoutRating || 0 },
      { label: "Avaliados", value: counters.withRating || 0 },
    ] : []),
  ];

  const iconToneClass = (tone) => {
    if (tone === "good") return classes.dashIconGood;
    if (tone === "warn") return classes.dashIconWarn;
    if (tone === "crit") return classes.dashIconCrit;
    return "";
  };

  return (
    <>
      {user.showDashboard !== "enabled" ? (
        <Redirect to="/tickets" />
      ) : (
        <MainContainer>
          {tokenWarning && (
            <div style={{
              margin: "8px 16px 0",
              padding: "10px 16px",
              background: "#ffebee",
              border: "1px solid #ef9a9a",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              gap: 8
            }}>
              <span style={{ fontSize: 20 }}>⚠️</span>
              <div>
                <strong style={{ color: "#c62828" }}>
                  Limite de IA quase esgotado — {tokenWarning.pct}% consumido
                </strong>
                <span style={{ color: "#666", marginLeft: 8, fontSize: 13 }}>
                  Entre em contato com o suporte para fazer upgrade e garantir que a IA continue respondendo.
                </span>
              </div>
            </div>
          )}
          <Paper
            className={classes.mainPaper}
            variant="outlined"
          >
            <Container maxWidth={false} className={classes.dashboardShell} style={{ maxWidth: '100%', overflowX: 'hidden' }}>
              <Grid2 container spacing={2} className={classes.container} style={{ margin: 0, width: '100%' }}>

                {/* CABEÇALHO EXECUTIVO */}
                <Grid2 item xs={12}>
                  <div className={classes.executiveHero}>
                    <div className={classes.dashHeaderRow}>
                      <div>
                        <Typography className={classes.heroEyebrow}>Inteligência Estratiza Hub</Typography>
                        <Typography className={classes.dashTitle}>Visão geral da operação</Typography>
                        <Typography className={classes.dashPeriodText}>
                          Performance, atendimento e experiência do cliente
                          <span className={classes.periodPill}>{periodLabel}</span>
                        </Typography>
                        <Typography style={{ marginTop: 8, fontSize: 12, color: "rgba(255,255,255,.72)" }}>
                          Métricas do período: {periodLabel} • {customPeriod ? "Filtro aplicado" : "Período padrão"}
                          {lastUpdatedAt ? ` • Atualizado às ${moment(lastUpdatedAt).format("HH:mm")}` : ""}
                        </Typography>
                      </div>
                      <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
                        <Button
                          onClick={toggleShowFilter}
                          className={classes.dashFilterBtn}
                          variant="outlined"
                          size="small"
                          style={{ color: "#FFFFFF", borderColor: "rgba(255,255,255,.58)", background: "rgba(255,255,255,.10)" }}
                          startIcon={!showFilter ? <FilterListIcon /> : <ClearIcon />}
                        >
                          {showFilter ? "Ocultar filtros" : "Filtros"}
                        </Button>
                        <Button
                          onClick={handleRefreshDashboard}
                          className={classes.dashRefreshBtn}
                          variant="contained"
                          size="small"
                          disableElevation
                          startIcon={<RefreshIcon style={{ fontSize: 17 }} />}
                        >
                          Atualizar dados
                        </Button>
                      </Box>
                    </div>
                  </div>
                </Grid2>

                {/* SITUAÇÃO AGORA */}
                <Grid2 item xs={12}>
                  <div className={classes.liveBand}>
                    <div className={classes.sectionHead} style={{ marginTop: 0, alignItems: "center" }}>
                      <div className={classes.liveHeaderMain}>
                        <FiberManualRecordIcon className={classes.liveDot} />
                        <Typography className={classes.sectionHeadTitle}>Situação agora</Typography>
                        <span className={classes.liveBadge}>● TEMPO REAL</span>
                      </div>
                      <Typography className={classes.sectionHeadHint}>Fotografia completa da operação neste momento</Typography>
                    </div>
                    <div className={classes.liveScope}>
                      Dados gerais e completos da empresa, sempre em tempo real — não usam o filtro de datas acima.
                    </div>
                    <Grid2 container spacing={2}>
                      {liveIndicators.map((ind, index) => (
                        <Grid2 item xs={12} sm={6} md={4} key={index}>
                          <div className={classes.dashCard}>
                            <span className={classes.liveCardBadge}>AGORA</span>
                            <div className={`${classes.dashIconWrap} ${iconToneClass(ind.tone)}`}>{ind.icon}</div>
                            <Typography className={classes.dashValue}>{ind.value}</Typography>
                            <Typography className={classes.dashLabel}>{ind.label}</Typography>
                            <Typography className={classes.dashSub}>{ind.subtext}</Typography>
                          </div>
                        </Grid2>
                      ))}
                    </Grid2>
                  </div>
                </Grid2>

                {showFilter && (
                  <Grid2 item xs={12} style={{ marginBottom: "8px" }}>
                    <Filters
                      classes={classes}
                      setDateStartTicket={setDateStartTicket}
                      setDateEndTicket={setDateEndTicket}
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      setQueueTicket={setQueueTicket}
                      queueTicket={queueTicket}
                      onApply={handleApplyPeriod}
                      loading={loading}
                    />
                  </Grid2>
                )}

                {/* RESULTADOS DO PERÍODO */}
                <Grid2 item xs={12}>
                  <div className={classes.sectionHead}>
                    <Typography className={classes.sectionHeadTitle}>Resultados do período</Typography>
                  </div>
                  <div className={classes.periodScope}>
                    {periodLabel} — estes resultados respeitam o filtro de datas selecionado.
                  </div>
                </Grid2>
                {[periodIndicators.finalizados, periodIndicators.novosContatos, periodIndicators.tempoMedioEspera].map((ind, index) => (
                  <Grid2 item xs={12} sm={6} lg={3} key={index}>
                    <div className={`${classes.dashCard} ${classes.featuredCard}`}>
                      <div className={`${classes.dashIconWrap} ${iconToneClass(ind.tone)}`}>{ind.icon}</div>
                      <Typography className={classes.dashValue}>
                        {ind.value}{ind.muted && <span className={classes.dashValueMuted}> {ind.muted}</span>}
                      </Typography>
                      <Typography className={classes.dashLabel}>{ind.label}</Typography>
                      <Typography className={classes.dashSub}>{ind.subtext}</Typography>
                      {ind.warning && <Typography className={classes.dashWarnNote}>⚠ {ind.warning}</Typography>}
                    </div>
                  </Grid2>
                ))}

                {/* Tabela de Atendentes — leitura gerencial logo após os KPIs */}
                <Grid2 item xs={12} style={{ marginTop: '10px' }}>
                  <div className={classes.sectionHead}>
                    <Typography className={classes.sectionHeadTitle}>Atendentes</Typography>
                    <Button size="small" variant="outlined" startIcon={<SaveAlt />} onClick={exportarGridParaExcel} style={{ textTransform: "none", fontWeight: 700, borderRadius: 10 }}>
                      Exportar Excel
                    </Button>
                  </div>
                  <Typography className={classes.sectionHeadHint} style={{ marginTop: -6, marginBottom: 6 }}>De acordo com o período filtrado acima. Médias no horário padrão: seg–sex, 08h–18h. Para analisar outros dias e horários, acesse Métricas de Atendimento.</Typography>
                  <div className={classes.tablePanel}>
                    <TableAttendantsStatus
                      attendants={attendants.map((a) => ({
                        ...a,
                        avgStartMinutes: rankingByUser[a.id]?.avgStartMinutes,
                        avgResponseMinutes: rankingByUser[a.id]?.avgResponseMinutes
                      }))}
                      loading={loading}
                      rankingLoading={rankingLoading}
                      userRatingEnabled={userRatingEnabled}
                    />
                  </div>
                </Grid2>

                {/* Pesquisa de Satisfação (NPS) -- so aparece se a empresa tem avaliacao habilitada */}
                {userRatingEnabled && (
                  <>
                    <Grid2 item xs={12}>
                      <div className={classes.sectionHead}>
                        <Typography className={classes.sectionHeadTitle}>Pesquisa de satisfação</Typography>
                      </div>
                    </Grid2>
                    <Grid2 item xs={12}>
                      <div className={classes.bentoPanel}>
                        <Grid2 container spacing={2} alignItems="stretch">
                          {npsRows.map((row, index) => (
                            <Grid2 item xs={12} sm={6} md={3} key={index}>
                              <div className={classes.npsCard}>
                          <div className={classes.npsTop}>
                            <span className={classes.npsLabel}>{row.label}</span>
                            <span className={classes.npsValue} style={{ color: row.color }}>{row.value}{row.label !== "Score (NPS)" ? "%" : ""}</span>
                          </div>
                          <div className={classes.npsBarTrack}>
                            <LinearProgress
                              variant="determinate"
                              value={row.value > 100 ? 100 : row.value}
                              style={{ height: 7, borderRadius: 100, backgroundColor: "transparent" }}
                              sx={{ "& .MuiLinearProgress-bar": { backgroundColor: row.color } }}
                            />
                          </div>
                              </div>
                            </Grid2>
                          ))}
                        </Grid2>
                      </div>
                    </Grid2>
                  </>
                )}

                {/* Informações de Atendimento */}
                <Grid2 item xs={12}>
                  <div className={classes.sectionHead}>
                    <Typography className={classes.sectionHeadTitle}>{userRatingEnabled ? "Atendimentos e avaliação" : "Atendimentos"}</Typography>
                  </div>
                </Grid2>
                <Grid2 item xs={12}>
                  <div className={classes.bentoPanel}>
                    <Grid2 container alignItems="center" spacing={2}>
                      {attendanceInfoCards.map((attInfo, index) => (
                        <Grid2 item xs={6} md={2} key={index}>
                          <div style={{ textAlign: "center", padding: "9px 4px" }}>
                            <Typography className={classes.dashValue}>{attInfo.value}</Typography>
                            <Typography className={classes.dashLabel}>{attInfo.label}</Typography>
                          </div>
                        </Grid2>
                      ))}
                      {userRatingEnabled && (
                        <Grid2 item xs={12} md={4}>
                          <Box display="flex" alignItems="center" style={{ gap: 14 }}>
                            <div className={classes.ratingBadge} style={{ textAlign: "center" }}>
                              {Number(counters.percRating / 100).toLocaleString(undefined, { style: 'percent' }) || "0%"}
                            </div>
                            <div style={{ flex: 1 }}>
                              <Typography className={classes.dashLabel} style={{ marginBottom: 7 }}>Índice de avaliação</Typography>
                              <div className={classes.npsBarTrack}>
                                <LinearProgress variant="determinate" value={counters.percRating || 0} style={{ height: 8, borderRadius: 100 }} />
                              </div>
                            </div>
                          </Box>
                        </Grid2>
                      )}
                    </Grid2>
                  </div>
                </Grid2>

                {/* Gráficos */}
                <Grid2 item xs={12}>
                  <div className={classes.sectionHead}>
                    <Typography className={classes.sectionHeadTitle}>Evolução e distribuição</Typography>
                  </div>
                </Grid2>
                <Grid2 container spacing={2} item xs={12}>
                  <Grid2 item xs={12} md={6}>
                    <div className={classes.chartPanel}>
                      <div className={classes.chartHead}>
                        <div>
                          <Typography className={classes.chartTitle}>Performance por atendente</Typography>
                          <Typography className={classes.chartHint}>Distribuição dos atendimentos entre a equipe</Typography>
                        </div>
                        <span className={classes.chartAccent} />
                      </div>
                      <ChatsUser
                        initialDate={dateStartTicket}
                        finalDate={dateEndTicket}
                        refreshKey={chartsRefreshKey}
                      />
                    </div>
                  </Grid2>
                  <Grid2 item xs={12} md={6}>
                    <div className={classes.chartPanel}>
                      <div className={classes.chartHead}>
                        <div>
                          <Typography className={classes.chartTitle}>Evolução do atendimento</Typography>
                          <Typography className={classes.chartHint}>Comportamento dos dados ao longo do período</Typography>
                        </div>
                        <span className={classes.chartAccent} />
                      </div>
                      <ChartsDate
                        initialDate={dateStartTicket}
                        finalDate={dateEndTicket}
                        refreshKey={chartsRefreshKey}
                      />
                    </div>
                  </Grid2>
                </Grid2>

                {/* LEITURA OPERACIONAL COMPLETA — fechamento analítico */}
                <Grid2 item xs={12}>
                  <div className={classes.sectionHead}>
                    <Typography className={classes.sectionHeadTitle}>Leitura operacional</Typography>
                    <Typography className={classes.sectionHeadHint}>Volume, origem e canais monitorados</Typography>
                  </div>
                </Grid2>
                <Grid2 item xs={12} md={6}>
                  <div className={classes.bentoPanel}>
                    <Typography className={classes.panelTitle}>Volume de mensagens</Typography>
                    <Typography className={classes.panelIntro}>Movimentação no período e total histórico da operação.</Typography>
                    {[periodIndicators.mensagensRecebidas, periodIndicators.mensagensEnviadas].map((ind, index) => (
                      <div className={classes.metricRow} key={index}>
                        <div>
                          <Typography className={classes.metricRowLabel}>{ind.label}</Typography>
                          <Typography className={classes.dashSub}>{ind.subtext}</Typography>
                        </div>
                        <Typography className={classes.metricRowValue}>
                          {ind.value}<span className={classes.dashValueMuted}> {ind.muted}</span>
                        </Typography>
                      </div>
                    ))}
                    <div className={classes.visibleNotice}>
                      <span>⚠</span>
                      <span>O histórico atual não identifica se o envio foi humano, IA, fluxo, chatbot ou campanha.</span>
                    </div>
                  </div>
                </Grid2>
                <Grid2 item xs={12} md={6}>
                  <div className={classes.bentoPanel}>
                    <Typography className={classes.panelTitle}>Origem dos atendimentos</Typography>
                    <Typography className={classes.panelIntro}>Atendimentos iniciados no período, incluindo novos contatos e clientes antigos que voltaram a conversar.</Typography>
                    {[periodIndicators.iniciadosPelaEmpresa, periodIndicators.iniciadosPeloCliente].map((ind, index) => (
                      <div className={classes.metricRow} key={index}>
                        <div>
                          <Typography className={classes.metricRowLabel}>{ind.label}</Typography>
                          <Typography className={classes.dashSub}>{ind.subtext}</Typography>
                        </div>
                        <Typography className={classes.metricRowValue}>{ind.value}</Typography>
                      </div>
                    ))}
                  </div>
                </Grid2>
              </Grid2>
            </Container>
          </Paper>
        </MainContainer>
      )}
    </>
  );
};

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  return hasRolloutFeature(user, ROLLOUT_FEATURES.DASHBOARD_V2)
    ? <PremiumDashboard />
    : <LegacyDashboard />;
};

export default Dashboard;
